export default __webpack_public_path__ + "static/media/faq_graphic.23106145.svg";